import { useEffect, useState } from 'react';

export function useUserWay() {
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    // Check if UserWay is already loaded
    const checkUserWay = () => {
      if (window.UserWay) {
        setReady(true);
        return true;
      }
      return false;
    };

    // Check immediately
    if (checkUserWay()) return undefined;

    // Poll for UserWay to be ready
    const interval = setInterval(() => {
      if (checkUserWay()) {
        clearInterval(interval);
      }
    }, 100);

    // Cleanup interval after 10 seconds
    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 10000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  const openWidget = () => {
    if (!window.UserWay) return;

    setLoading(true);

    window.UserWay.widgetOpen();
    const observer = new MutationObserver(() => {
      const panel =
        document.querySelector('#userway-widget') || document.querySelector('.userway_widget');

      if (panel) {
        setLoading(false);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    setTimeout(() => {
      setLoading(false);
      observer.disconnect();
    }, 3000);
  };

  return {
    openWidget,
    loading,
    ready,
  };
}
